var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-banner",style:(_vm.bannerVars)},[_c('div',{staticClass:"core-container page-banner__inner",class:{ 'page-banner__inner--safe': _vm.safeBottom }},[_c('div',{staticClass:"page-banner__media"},[_c('img',{staticClass:"page-banner__img",attrs:{"src":_vm.src,"alt":_vm.alt}})]),(_vm.safeBottom)?_c('div',{staticClass:"page-banner__safe",attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.$slots.default)?_c('div',{class:[
        'page-banner__content',
        { 'is-align-start': _vm.contentAlign === 'start' },
        { 'is-align-end': _vm.contentAlign === 'end' }
      ]},[_vm._t("default")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }